// Angular
import { Component, OnInit } from "@angular/core";
// Models
import { ElasticService } from "./../../services/elastic";

import { Tournament } from "./../../models/tournament";
// Services
import { ApiService } from "./../../services/api";
import * as lodash from "lodash";
import {
  AngularFireDatabase,
  FirebaseListObservable,
} from "angularfire2/database";
import { DatePipe } from "@angular/common";
import { OAuthService } from "./../../services/o-auth";
import { async } from "@angular/core/testing";
import { Router } from "@angular/router";

@Component({
  templateUrl: "./tournaments.component.html",
})
export class TournamentsComponent implements OnInit {
  public filterargs: any;

  public imageLoader = false;
  public tournaments: Array<any>;
  public maxPage: number;
  public typingDelay: any;
  public pageSize: number;
  currentPage;
  public user: any;
  constructor(
    private elasticService: ElasticService,
    private apiService: ApiService,
    private fireDatabase: AngularFireDatabase,
    private oAuthService: OAuthService,
    private router: Router
  ) {
    this.filterargs = new Tournament();
    this.currentPage = 0;
    this.pageSize = 30;
  }

  ngOnInit() {
    this.user = this.oAuthService.getClub();
    this.goToPage(0);
  }

  public filterChange() {
    // this.filterargs.startDate = this.datePipe.transform(event, 'yyyy-MM-dd')
    this.goToPage(0);
  }

  async checkIfMultiround(id) { // deleting single round of a multiround tournament
    this.fireDatabase.object(`tournaments/${id}`).subscribe(result => {
      let tournament = result;
      if (tournament.multiRoundId)
      {
        this.fireDatabase.database.ref(`multi-round/${tournament.multiRoundId}`).once("value", (res: any) => {
          if (res.val()) {
            res = res.val();
            let rounds = res.tournamentsRound;
            let count = res.numberOfRounds
            if(count>=1)
            this.fireDatabase.database.ref(`/multi-round/${tournament.multiRoundId}`).child('numberOfRounds').set(count - 1);
            let updatedRounds = rounds.filter(element => {
              if (element == id) return false
              else return true
            });
            this.fireDatabase.database.ref(`/multi-round/${tournament.multiRoundId}`).child('tournamentsRound').set(updatedRounds);
          }
        });
      }
    });
  }
  
  public clearTournament(id) {
    if (confirm("Are you sure? You want to clear the tournament")) {
      this.checkIfMultiround(id);
      this.apiService.set(`server-process/clear-tournament/${id}`, id);
    }
  }

  public deleteTournament(id) {
    if (confirm("Are you sure? You want to delete the tournament")) {
      this.checkIfMultiround(id);
      this.apiService.set(`/tournaments/${id}/isDelete`, true);
      this.apiService.set(`server-process/clear-tournament/${id}`, id);
      this.ngOnInit();
    }
  }

  goToPage(index: number) {
    const fromIndex = index * this.pageSize;
    let queryParams = {};

    queryParams = {
      index: "tournaments",
      type: "tournament",
      size: this.pageSize,
      from: fromIndex,
      "body/sort/startDate/order": `desc`,
    };

    if (
      this.filterargs.clubName != undefined &&
      this.filterargs.clubName != "" && this.filterargs.clubName.trim() != ""
    ) {
      queryParams[
        "body/query/bool/must/1/match_phrase_prefix/clubName"
      ] = `*${this.filterargs.clubName.trim().toLowerCase()}*`;
      if (this.user.type == 1) {
        let sa = this.user.cid.split("-");
        let s = "";
        sa.map((x) => {
          s = s + x;
        });
        queryParams["body/query/bool/must/0/match/es_cid"] = s;
      }
    }
    if (this.user.type == 6 || this.user.type == 7) {
      queryParams["body/query/bool/must/1/match/uid"] = this.user.cid;
    }

    if (this.user.type == 1) {
        let sa = this.user.cid.split("-");
        let s = "";
        sa.map((x) => {
          s = s + x;
        });
        queryParams["body/query/bool/must/1/match/es_cid"] = s;
      }
 
    if (
      this.filterargs.eventName != undefined &&
      this.filterargs.eventName != "" && 
      this.filterargs.eventName.trim() != ""
    ) {
      queryParams["body/query/bool/must/0/match_phrase_prefix/eventName"] =
        `*${this.filterargs.eventName.trim().toLowerCase()}*`
    }
    if (
      this.filterargs.startDate != undefined &&
      this.filterargs.startDate != ""
    ) {
      const date = new Date(this.filterargs.startDate);
      const dateEnd = new Date(
        new Date(this.filterargs.startDate).setHours(23, 59, 59)
      );
      queryParams["body/query/bool/filter/0/range/startDate/gte"] =
        date.getTime() / 1000;
      queryParams["body/query/bool/filter/0/range/startDate/lte"] =
        dateEnd.getTime() / 1000;
    }
    this.elasticService
      .search(queryParams)
      .then((result) => {
        if (result) {
          this.tournaments = [];
          lodash.forEach(result["hits"], async (item) => {
            let club = item["_source"];
            if (!club.isDelete) {
              club.startTime = parseFloat(club.startDate) * 1000;
              club.endTime = parseFloat(club.endDate) * 1000;
              const current = new Date().getTime();
              club.delete = false;
              club.isFinished = true;
              club.delete =
                Math.floor((club.startTime - current) / (60 * 60 * 1000)) > 24;
              club.isFinished =
                Math.floor(
                  Math.abs((club.startTime - current) / (60 * 60 * 1000))
                ) < 24;
              if (current > club.endTime) {
                club.status = "Finished";
              } else if (club.startTime > current) {
                const days = Math.floor(
                  Math.abs((club.startTime - current) / (24 * 60 * 60 * 1000))
                );
                if (days < 1) {
                  club.status =
                    (await this.getTimeDifference(club.startDate)) + "to start";
                } else {
                  club.status =
                    (await this.getTimeDifference(club.startDate)) + "to start";
                  club.delete = true;
                }
              } else {
                club.status = "Active";
              }
              const date = new Date(club.startTime);

              const o =
                date.getFullYear() +
                "-" +
                ("0" + (date.getMonth() + 1)).slice(-2) +
                "-" +
                ("0" + date.getDate()).slice(-2);

              club.startDate = o;
              // if (this.user.type == 3 && this.user.role == 1)
              // {
              //   if (club.uid == this.user.uid && club.userId != this.user.uid)
              //   {
              //      this.tournaments.push(lodash.assign({ $key: item["_id"] }, club));
              //         this.tournaments.sort(($0, $1) => {
              //         return $1.startTime - $0.startTime; });
              //     }
              //   }
              // else
              if (this.user.type == 1) // 1,6,7
              {
                if (club.cid == this.user.cid) // played at this club
                {

                  if (this.user.role == 3)
                  {
                    if (this.user.uid == club.userId)
                    {
                      this.tournaments.push(lodash.assign({ $key: item["_id"] }, club));
                      this.tournaments.sort(($0, $1) => {
                      return $1.startTime - $0.startTime; });
                    }
                  }
                  else {
                      this.tournaments.push(lodash.assign({ $key: item["_id"] }, club));
                      this.tournaments.sort(($0, $1) => {
                      return $1.startTime - $0.startTime; });
                    }
                }
              }
              else {
                this.tournaments.push(lodash.assign({ $key: item["_id"] }, club));
                 this.tournaments.sort(($0, $1) => {
                return $1.startTime - $0.startTime;
              });
              }
              // this.tournaments.push(lodash.assign({ $key: item["_id"] }, club));
              // this.tournaments.sort(($0, $1) => {
              //   return $1.startTime - $0.startTime;
              // });
            }
          });
          // this.imageLoader = false;

          window.scrollTo(0, 0);
          this.currentPage = index;
          this.maxPage = Math.ceil(result["total"] / this.pageSize);
        } else {
          this.tournaments = [];
        }
        this.imageLoader = false;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  public getTimeDifference(givenTime: number) {
    const current = new Date().getTime() / 1000;
    const min = Math.abs((current - givenTime) / 60);
    const hour = min / 60;
    const day = hour / 24;
    const month = day / 30;
    const year = month / 12;
    if (year < 1) {
      if (month < 1) {
        if (day < 1) {
          if (hour < 1) {
            if (min > 10) {
              return parseInt(min + "") + " min ";
            } else {
              return "few mins ";
            }
          } else {
            if (hour < 2) {
              return parseInt(hour + "") + " hr ";
            } else {
              return parseInt(hour + "") + " hrs ";
            }
          }
        } else {
          const d = parseInt(day + "");
          const rh = parseInt(hour - 24 * d + "");
          if (day < 2) {
            return d + " day " + rh + " hrs ";
          } else {
            return d + " day " + rh + " hrs ";
          }
        }
      } else {
        if (month < 2) {
          return parseInt(month + "") + " month ";
        } else {
          return parseInt(month + "") + " months ";
        }
      }
    } else {
      if (year < 2) {
        return parseInt(year + "") + " year ";
      } else {
        return parseInt(year + "") + " years ";
      }
    }
  }
  goNext() {
    const index = this.currentPage + 1;
    this.goToPage(index);
  }

  goPrev() {
    const index = this.currentPage - 1;
    this.goToPage(index);
  }

  getIndex(index: number) {
    return this.currentPage * this.pageSize + index + 1;
  }
  changeQuery() {
    clearTimeout(this.typingDelay);

    this.typingDelay = setTimeout(() => {
      this.currentPage = 0;
      this.goToPage(this.currentPage);
    }, 400);
  }
  reset() {
    this.filterargs = new Tournament();
    this.filterChange();
  }

  onShowClick(tournament) {
    if (tournament.type == 2) {
      return `/components/tournaments-matchplay-details/${tournament.$key}`;
    } else {
      if (this.currentPage)
        return `/components/tournamentDetail/${tournament.$key}/${this.currentPage}`;
      else return `/components/tournamentDetail/${tournament.$key}`;
    }
  }
}
